export default __webpack_public_path__ + "static/media/hackerrank.74d3ca84.png";